import type { QueryApi } from "../../api/query";

export function createUsePopularProjects($api: QueryApi) {
  return function usePopularProjects(params: { page?: number; size: number }) {
    return $api.useQuery("get", "/projects/withAssociations", {
      params: { query: { page: params.page ?? 0, size: params.size } },
    }, {
      staleTime: 5 * 60_000,
    });
  };
}
